import { hydrate } from "../hydrate.tsx";
import { SearchBar, type SearchBarProps } from "./SearchBar.tsx";

hydrate<SearchBarProps>("search-bar-island", (props) => <SearchBar {...props} />);
